/**
 * Sprint 24.5 — ToolsetCheckboxRow.
 *
 * One selectable toolset row in the install wizard's toolset step (M365: Mail,
 * Calendar, Contacts, OneDrive, Teams). Sub-primitive of InstallStepToolsets;
 * reused by any template that declares a toolset selection.
 */

import type { CSSProperties } from "react";
import type { FirstPartyTemplateToolset } from "../../../../hooks/use-first-party-templates";

export interface ToolsetCheckboxRowProps {
  toolset: FirstPartyTemplateToolset;
  checked: boolean;
  onToggle: () => void;
}

export function ToolsetCheckboxRow({ toolset, checked, onToggle }: ToolsetCheckboxRowProps) {
  return (
    <label style={row}>
      <input type="checkbox" checked={checked} onChange={onToggle} style={checkbox} />
      <i className={`ti ti-${toolset.icon}`} style={icon} aria-hidden="true" />
      <span style={name}>{toolset.name}</span>
      <span style={count}>{toolset.tool_count_estimate} tools</span>
    </label>
  );
}

const row: CSSProperties = {
  background: "var(--color-background-secondary)",
  borderRadius: "var(--border-radius-md)",
  padding: "7px 10px",
  display: "flex",
  alignItems: "center",
  gap: 8,
  cursor: "pointer",
  fontSize: 11,
  fontFamily: "var(--font-sans)",
};

const checkbox: CSSProperties = { cursor: "pointer", flexShrink: 0 };
const icon: CSSProperties = { fontSize: 13, color: "var(--color-text-secondary)", flexShrink: 0 };
const name: CSSProperties = { flex: 1, color: "var(--color-text-primary)" };
const count: CSSProperties = { fontSize: 9, color: "var(--color-text-tertiary)", whiteSpace: "nowrap" };
